import classes from '@src/styles/WordpressSummary.module.css'
import parse from 'html-react-parser';

function WordpressPostSummary ({ post, group }: any) {
  const titleName = post?.title?.rendered?.split("#038;")?.join("") ?? "Post";
  const image = post?.jetpack_featured_media_url ?? "";
  const excerpt = post?.excerpt?.rendered?.split("#038;")?.join("") || "Excerpt";
  const link = `/${group}/${post?.slug ?? ""}`;
  return (
    <div className={classes.container}>
      <h2>{titleName}</h2>
      <div className={classes.content} style={{ display: !image ? "block" : undefined }}>
        {image && (
          <div className={classes.imageContainer}>
            <img alt={post?.slug} src={image} />
          </div>
        )}
        <div>
          <div className={classes.previewContainer}>{parse(excerpt ?? "")}</div>
          <a className={classes.link} href={link}>Read More</a>
        </div>
      </div>
    </div>
  )
};

export default WordpressPostSummary;